module.exports = __webpack_public_path__ + "img/3_2.7f6a8ff9.png";